import ArtisanInvoiceListHidden from '../components/ArtisanInvoiceListHidden'

export const artisanPages = {
  root: '/artisan/:id',
  profile: {
    name: '/artisan/:id/profile',
    navigate: (id: number) => `/artisan/${id}/profile`,
  },
  subscription: {
    name: '/artisan/:id/subscription',
    navigate: (id: number) => `/artisan/${id}/subscription`,
  },
  efacture: {
    name: '/artisan/:id/efacture',
    navigate: (id: number) => `/artisan/${id}/efacture`,
  },
  interventionList: {
    name: '/artisan/:id/interventionList',
    navigate: (id: number) => `/artisan/${id}/interventionList`,
  },
  interventionListHidden: {
    name: '/artisan/:id/interventionListHidden',
    navigate: (id: number) => `/artisan/${id}/interventionListHidden`,
  },
  quotationList: {
    name: '/artisan/:id/quotationList',
    navigate: (id: number) => `/artisan/${id}/quotationList`,
  },
  quotationListHidden: {
    name: '/artisan/:id/quotationListHidden',
    navigate: (id: number) => `/artisan/${id}/quotationListHidden`,
  },
  invoiceList: {
    name: '/artisan/:id/invoiceList',
    navigate: (id: number) => `/artisan/${id}/invoiceList`,
  },
  invoiceListHidden: {
    name: '/artisan/:id/invoiceListHidden',
    navigate: (id: number) => `/artisan/${id}/invoiceListHidden`,
  },
  clientList: {
    name: '/artisan/:id/clientList',
    navigate: (id: number) => `/artisan/${id}/clientList`,
  },
  dashboard: {
    name: '/artisan/:id/dashboard',
    navigate: (id: number) => `/artisan/${id}/dashboard`,
  },
  facturation: {
    name: '/artisan/:id/facturation',
    navigate: (id: number) => `/artisan/${id}/facturation`,
  },
  extracts: {
    name: '/artisan/:id/extracts',
    navigate: (id: number) => `/artisan/${id}/extracts`,
  },
  upload: {
    name: '/artisan/:id/upload',
    navigate: (id: number) => `/artisan/${id}/upload`,
  },
  uploadProducts: {
    name: '/artisan/:id/upload/products',
    navigate: (id: number) => `/artisan/${id}/upload/products`,
  },
  uploadClients: {
    name: '/artisan/:id/upload/clients',
    navigate: (id: number) => `/artisan/${id}/upload/clients`,
  },
}
